define('AwaLabs.AllowVintage', [
    'jQuery',
    'underscore'
], function AwaLabsAllowVintage(
    jQuery,
    _
) {
    'use strict';

    return {
        mountToApp: function mountToApp(application) {
            var cart = application.getComponent('Cart');
            if (cart) {
                cart.addToViewContextDefinition('Cart.Lines.View', 'isWine', 'string', function fnIsWine(context) {
                    var option;
                    if (context && context.line && context.line.item && context.line.item.options) {
                        option = _.findWhere(context.line.item.options, { cartOptionId: 'custcol_accept_vintage_substitution' });
                    }
                    return option;
                });
                cart.addToViewContextDefinition('Cart.Lines.View', 'vintage', 'string', function fnVintage(context) {
                    return context.line && context.line.item && context.line.item.custitem_aws_vintage;
                });
                cart.addToViewContextDefinition('Cart.Lines.View', 'acceptVintageSelected', 'string', function fnAcceptVintageSelected(context) {
                    var option;
                    var acceptVintageSelected;
                    if (context.line && context.line.options && context.line.options.length) {
                        option = _.findWhere(context.line.options, { cartOptionId: 'custcol_accept_vintage_substitution' });
                        acceptVintageSelected = option && option.value && option.value.internalid === 'T';
                    }
                    return acceptVintageSelected;
                });
                cart.addToViewEventsDefinition('Cart.Lines.View', 'change [data-action="allow-vintage"]', function fnAllowVintage(e) {
                    var isChecked = jQuery(e.target).is(':checked');
                    var internalid = jQuery(e.target).data('id');
                    var value = isChecked ? 'T' : 'F';
                    var line;
                    var option;
                    var lineOption;
                    cart.getLines().done(function onDone(lines) {
                        line = _.findWhere(lines, { internalid: internalid });
                        if (line) {
                            if (line.item && line.item.extras && line.item.extras.options) {
                                option = _.findWhere(line.item.extras.options, { cartOptionId: 'custcol_accept_vintage_substitution' });
                                if (option) {
                                    option.value = { internalid: value };
                                    if (line.options) {
                                        lineOption = _.findWhere(line.options, { cartOptionId: 'custcol_accept_vintage_substitution' });
                                        if (lineOption) {
                                            lineOption.value = option.value;
                                        } else {
                                            line.options.push(option);
                                        }
                                    } else {
                                        line.options = [option];
                                    }
                                    cart.updateLine({ line: line }).fail(function onFail() {
                                        jQuery(e.target).prop('checked', !isChecked);
                                    });
                                }
                            }
                        }
                    });
                });
            }
        }
    };
});
